import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { useContent } from "../../context/ContentContext";

const KEY = "peca_cookie_consent";

const T = {
  pt: {
    text: "Usamos cookies essenciais para o site funcionar. Ao continuares, aceitas a nossa",
    policy: "Política de Cookies",
    accept: "Aceitar",
  },
  en: {
    text: "We use essential cookies to make the site work. By continuing, you accept our",
    policy: "Cookie Policy",
    accept: "Accept",
  },
};

export default function CookieBanner() {
  const { locale, content } = useContent();
  const { pathname } = useLocation();
  const legal = content?.legal || {};
  const fb = T[locale] || T.pt;
  const t = {
    text: legal.cookieText || fb.text,
    policy: legal.cookiePolicyLabel || fb.policy,
    accept: legal.cookieAccept || fb.accept,
  };
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const done = localStorage.getItem(KEY);
    if (!done) {
      const id = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(id);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  if (!visible || pathname.startsWith("/portal")) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[9997] bg-peca-surface border border-peca-yellow p-5 shadow-[6px_6px_0_0_rgba(230,255,0,0.15)] animate-in"
      style={{ animation: "cookieUp 0.5s cubic-bezier(0.16,1,0.3,1)" }}
    >
      <style>{`@keyframes cookieUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div className="flex items-start justify-between gap-3">
        <p className="text-peca-cream text-sm leading-relaxed">
          {t.text}{" "}
          <Link to="/cookies" data-testid="cookie-policy-link" className="text-peca-yellow underline underline-offset-2 hover:text-peca-cream transition-colors">
            {t.policy}
          </Link>
          .
        </p>
        <button onClick={accept} aria-label="Fechar" className="text-peca-grey hover:text-peca-yellow transition-colors shrink-0">
          <X size={18} />
        </button>
      </div>
      <button
        onClick={accept}
        data-testid="cookie-accept"
        className="mt-4 inline-flex items-center gap-2 bg-peca-yellow text-peca-black font-display font-bold uppercase text-xs tracking-wide px-5 py-3 hover:bg-peca-cream transition-colors duration-200"
      >
        {t.accept}
      </button>
    </div>
  );
}
